import * as React from 'react';

import { Bell } from 'lucide-react';

import { Badge, Drawer } from '@mui/material';

import { useNotificationCount } from '@itp/talent';
import { theme } from '@itp/talent/theme';

import { IconButton } from '../../core/button';
import { NotificationsDropdown } from './notificationsDropdown';

export const NotificationsMenu = () => {
  const { unread } = useNotificationCount();
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <IconButton
        sx={{
          height: theme.spacing(6),
          minHeight: theme.spacing(6),
          minWidth: theme.spacing(6),
          width: theme.spacing(6),
        }}
        aria-controls="notifications"
        aria-haspopup="true"
        aria-label="Notifications"
        color="inherit"
        edge="end"
        onClick={() => setOpen(true)}
        size="large"
      >
        <Badge badgeContent={unread} color="error">
          <Bell
            color={
              (unread > 0 ? theme.topNavigation.active : theme.palette.secondary.main) as string
            }
            size={20}
          />
        </Badge>
      </IconButton>
      <Drawer
        slotProps={{
          paper: {
            sx: {
              height: '100dvh',
              overflow: 'hidden',
              width: { sm: '400px', xs: '100%' },
            },
          },
        }}
        anchor="right"
        onClose={() => setOpen(false)}
        open={open}
      >
        <NotificationsDropdown show={open} />
      </Drawer>
    </>
  );
};
